import { NavHeader, SubPage } from './nav-header';
import { CompaniesDropDown } from './companies-dropdown';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/configure-store';

interface PageNavBarProps {
    mainPage: string
}

const globalPages: SubPage[] = [
    { label: 'Objectives', route: 'objectives' },
    { label: 'Systems', route: 'systems' },
    { label: 'Companies', route: 'companies' },
    { label: 'Agent Script Hash Registry', route: 'agent-hashes' },
]

const companyPages: SubPage[] = [
    { label: 'Audit Controls', route: 'audit-controls' },
    { label: 'Entities', route: 'entities' },
    { label: 'Entity Systems', route: 'entity-systems' },
    { label: 'Users', route: 'users' },
    { label: 'ETL Customizations', route: 'etl-customizations', preserveSearch: true },
    { label: 'Rule Manager Customizations', route: 'rule-manager-customizations' },
    {
        label: 'Audit Trails',
        route: 'audit-trails',
        title: 'Audit Trails',
        iconOnly: true,
        icon: (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5l3 2" />
            </svg>
        ),
    },
]

const awsPages: SubPage[] = [
    { label: 'ETL Schedules', route: 'glue-triggers' },
    {
        label: 'Audit Trails',
        route: 'audit-trails',
        title: 'Audit Trails',
        iconOnly: true,
        icon: (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5l3 2" />
            </svg>
        ),
    },
]

const formPages: SubPage[] = [
    { label: 'Add Audit Control', route: 'add-audit-control' },
]

export const PageNavBar: React.FC<PageNavBarProps> = ({ mainPage }) => {
    const companies = useSelector((state: RootState) => state.companies.value)

    if (mainPage === 'aws') {
        return (
            <div className='page-nav-area'>
                <div className='page-nav-area__top' />
                <div className='page-nav-area__tabs'>
                    <NavHeader subPages={awsPages} preserveCompany={false} />
                </div>
            </div>
        )
    }

    if (mainPage === 'forms') {
        return (
            <div className='page-nav-area'>
                <div className='page-nav-area__tabs'>
                    <NavHeader subPages={formPages} />
                </div>
            </div>
        )
    }

    if (mainPage === 'company') {
        return (
            <div className='page-nav-area'>
                <div className='page-nav-area__top'>
                    <CompaniesDropDown companies={companies} />
                </div>
                <div className='page-nav-area__tabs'>
                    <NavHeader subPages={companyPages} />
                </div>
            </div>
        )
    }

    return (
        <div className='page-nav-area'>
            <div className='page-nav-area__top' />
            <div className='page-nav-area__tabs'>
                <NavHeader subPages={globalPages} preserveCompany={false} />
            </div>
        </div>
    );
}
